<template>
  <section
    id="intro"
    class="text-center mb-12"
  >
    <h1 class="display-2 font-weight-light mb-8">
      {{ gallery.title }}
    </h1>

    <v-responsive
      class="mx-auto subtitle-1 grey--text"
      max-width="550"
    >
      {{ gallery.blurb }}
    </v-responsive>
  </section>
</template>

<script>
  export default {
    name: 'Headline',
    props: {
      path: String,
      gallery: Object,
    },
  }
</script>
